import { Theme } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import useMediaQuery from '@material-ui/core/useMediaQuery';

/** Hook to determine weather a component should be full screen */
export function useFullscreen(breakpoint: Breakpoint | number = 'sm') {
  const theme = useTheme<Theme>();
  return useMediaQuery(theme.breakpoints.down(breakpoint));
}
